import script from "./UsersAppLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersAppLayout.vue?vue&type=script&setup=true&lang=ts"

import "./UsersAppLayout.vue?vue&type=style&index=0&id=2c71f058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c71f058"]])

export default __exports__